export default "__VITE_ASSET__15bfac12__"